<template>
  <div class="row text-center justify-content-center">
    <div class="col-10 col-md-4 card">
      <form v-on:submit="doLogin">
        <div class="title w-100 text-center">
          <img src="../assets/logo.png" class="main-logo"/>
        </div>
        <div class="form-group mt-5">
          <div v-if="error" class="alert alert-danger" role="alert">
            {{ error }}
          </div>
          <label class="sr-only" for="email">Correo Electrónico</label>
            <div class="input-group mb-2 mr-sm-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <img src="../assets/glyph-iconset/si-glyph-mail-white.svg" width="20"/>
                  </div>
                </div>
                <input
                  type="email"
                  v-model="username"
                  class="form-control"
                  id="email"
                  aria-describedby="emailHelp"
                  placeholder="Correo Electroónico"
                />
              </div>
        </div>

        <div class="form-group">
          <label  class="sr-only" for="password">Contraseña</label>
            <div class="input-group mb-2 mr-sm-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <img src="../assets/glyph-iconset/si-glyph-lock-white.svg" width="20"/>
                  </div>
                </div>
                <input
                        type="password"
                        v-model="password"
                        class="form-control"
                        id="password"
                        aria-describedby="emailHelp"
                        placeholder="Contraseña"
                      />
              </div>



        </div>
        <div class="form-group w-100 text-center">
          <button
            v-on:click="doLogin()"
            type="submit"
            class="btn btn-primary mb-2 btn-app"
          >
            Ingresar
          </button>
        </div>
      </form>
      <div class="notes text-right row">
        <div class="col-12 text-right">
          <button
            v-on:click="doRecoverPassword()"
            type="button"
            class="btn btn-link"
          >
            Olvidaste tu contraseña
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Odoo from "odoo-xmlrpc";
import NProgress from 'nprogress';

export default {
  name: "Login",
  data: function() {
    return {
      username: "",
      password: "",
      error: ""
    };
  },
  methods: {
    doRecoverPassword: function(e) {
      this.$router.push("recoverPassword");
    },
    doLogin: function(event) {
      if (event == undefined) return;
      event.preventDefault();
      this.error = "";
      var self = this;
      let requestBody = {
        params: {
          login: self.username != null ? self.username : "",
          password: self.password != null ? self.password : ""
        }
      };
      let url = self.$store.state.connection.url;
      NProgress.start();
      self.$http
        .post(url + "login", requestBody)
        .then(result => {
          if (result.body.result) {
            self.$ls.set("token", result.data.result.token);
            self.$ls.set("username", result.data.result.username);
            self.$ls.set("document", result.data.result.doc_number);
            self.$store.commit("setCredentials", self.username, self.password);
            self.$router.push("home");
          } else if (result.body.error) {
            self.error = result.data.error.data.message;
          }
          NProgress.done();
        })
        .catch(err => {
          console.error(err);
          NProgress.done();
        });
    }
  }
};
</script>

<style scoped>
.card .title {
  margin-top: 20px;
}

.btn-app{
    background-color: transparent !important;
    border-color: #ffffff !important;
    margin-top: 15px;
}
button{
    width: 100%;
    font-size: 18px;
}
button.bnt{
  border: 1px solid #ffffff !important;
}

.btn-app:hover{
  border: 1px solid #ffffff !important;
  background-color: #fff !important;
  color: rgba(211, 99, 0, 0.7);;
}

.main-logo{
    max-width: 260px;
    margin-bottom: 30px;
}
input{
  background-color: rgba(255, 255, 255, 0.25) !important;
  color: #fff !important;
  font-size: 16px;
  padding: 20px;
}
.input-group-text{
  background-color: rgba(255, 255, 255, 0.25) !important;
}
::-webkit-input-placeholder { /* Chrome */
  color: #fff !important;
  opacity: 1 !important;
  font-size: 16px;
}
::placeholder { /* Chrome */
  color: #fff !important;
  opacity: 1 !important;
  font-size: 16px;
}
.alert-danger{
  color: #fff !important;
  border: none;
  background-color: transparent;
  text-align: left;
}
</style>
